/**
 * RFC 4180 に従い CSV の 1 セルをエスケープする。
 * カンマ・ダブルクォート・改行のいずれかを含む値はダブルクォートで囲み、
 * 値中の `"` は `""` にエスケープする。
 * 該当文字を含まない値はそのまま返す（クォート不要）。
 */
const escapeCsvValue = (v: string): string =>
  /[",\r\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;

/**
 * 用語集 CSV テンプレートの本文文字列を組み立てる（BOM 付き UTF-8）。
 * セルは `escapeCsvValue` でエスケープするため、将来の翻訳値にカンマ等が
 * 入っても CSV が壊れない。
 * @param header - ヘッダー行の列名。デフォルトは日本語（言語 / 語句 / 読み方）。
 */
export const buildTemplateCsv = (
  header: [string, string, string] = ['言語', '語句', '読み方'],
): string => {
  const rows: string[][] = [
    header as string[],
    ['jpn', 'Pocketalk', 'ポケトーク'],
    ['eng-US', 'Pocketalk', 'Pocket Talk'],
    ['jpn', 'Sentio', 'センティオ', 'せんてぃお'],
  ];

  // BOM（U+FEFF）付き UTF-8 で出力するため、Excel で文字化けしない。
  return `\uFEFF${rows
    .map((r) => r.map(escapeCsvValue).join(','))
    .join('\r\n')}`;
};

/**
 * 用語集 CSV のテンプレートファイルをブラウザにダウンロードさせる。
 * BOM（U+FEFF）付き UTF-8 で出力するため、Excel で文字化けしない。
 * @param header - ヘッダー行の列名。デフォルトは日本語（言語 / 語句 / 読み方）。
 */
export const downloadTemplateCsv = (
  header: [string, string, string] = ['言語', '語句', '読み方'],
): void => {
  const csv = buildTemplateCsv(header);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = 'glossary_template.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
